// AI client — talks to THIS project's own backend (not the shared Mobile backend),
// which runs the OpenAI gpt-5.6-terra calls via the Emergent Universal Key.
import { getToken } from "./api";

const LOCAL = (process.env.REACT_APP_BACKEND_URL || "").replace(/\/+$/, "") || window.location.origin;

async function post(path, body) {
  const res = await fetch(`${LOCAL}/api${path}`, {
    method: "POST",
    headers: { "Content-Type": "application/json", ...(getToken() ? { Authorization: `Bearer ${getToken()}` } : {}) },
    body: JSON.stringify(body),
  });
  const data = await res.json().catch(() => ({}));
  if (!res.ok) throw new Error(typeof data.detail === "string" ? data.detail : "O assistente está indisponível. Tente novamente.");
  return data;
}

export async function aiAssistant(messages, context) {
  const { reply } = await post("/ai/assistant", { messages, context });
  return reply;
}

export async function aiLyrics(title, lyrics, mode) {
  const { text } = await post("/ai/lyrics", { title, lyrics, mode });
  return text;
}
